import { Box, Card } from 'lucid-components-react';
import React from 'react';

import Link from 'components/link/link';
import { Drupal_ParagraphFullCard } from 'generated/graphql';
import { mqMin } from 'theme/base';
import { LucidTheme } from 'types/types';

interface CardTilesProps {
  tiles: Drupal_ParagraphFullCard[];
}

const CardTiles = ({ tiles }: CardTilesProps) => {
  return (
    <Box
      as="section"
      css={{
        label: 'cardsContainer',
        [mqMin.tablet]: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          '& > div': {
            flex: '0 1 31%',
            maxWidth: '31%'
          }
        }
      }}
      pb={{ default: 4 }}
      pt={{ default: 4 }}
    >
      {tiles.map(({ fieldCtaHeading, fieldLink, fieldImage }, index) => {
        return (
          <Box
            key={fieldCtaHeading || `card-tiles-${index}`}
            // className="card--thirds"
            css={{ label: 'cardContainer' }}
            pb={{ default: 2, mobile: 2 }}
            pt={{ default: 2, mobile: 2 }}
          >
            <Card
              css={{
                label: 'card',
                [mqMin.tablet]: {
                  height: '100%'
                }
              }}
              mb={{ default: 3 }}
              variant="interactive"
            >
              <Link
                // className="card__wrapper"
                css={{
                  label: 'cardLinkWrapper',
                  width: '100%',
                  [mqMin.mobile]: {
                    maxHeight: '20em'
                  },
                  [mqMin.tabletSmall]: {
                    maxHeight: '23em'
                  },
                  [mqMin.tablet]: {
                    maxHeight: '28.75em'
                  }
                }}
                to={fieldLink || `card-tiles-link-${index}`}
                underline="none"
              >
                {/* 4:3 Aspect Ratio (divide 3 by 4 = 0.75) */}
                {fieldImage && (
                  <Card.Image
                    css={(theme: LucidTheme) => ({
                      label: 'cardImage',
                      position: 'relative',
                      maxHeight: '12.5em',
                      margin: theme.space[3],
                      '&::before': {
                        display: 'block',
                        content: '""',
                        paddingTop: '75%'
                      },
                      [mqMin.tabletSmall]: {
                        maxHeight: '15em'
                      }
                    })}
                  >
                    <Box
                      css={{
                        label: 'cardBGImage',
                        backgroundImage: `url(${fieldImage})`,
                        height: '100%',
                        width: '100%',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundClip: 'content-box',
                        position: 'absolute',
                        top: 0,
                        bottom: 0
                      }}
                    />
                  </Card.Image>
                )}
                <Box
                  css={(theme: LucidTheme) => ({
                    label: 'cardDivider',
                    borderBottom: `1px solid ${theme.colors.coolGrey[5]}`
                  })}
                />
                <Box
                  css={{
                    height: '100%'
                  }}
                >
                  <Card.Content
                    css={{
                      label: 'cardContent',
                      height: '100%',
                      [mqMin.tablet]: {
                        maxHeight: '8em',
                        justifyContent: 'center'
                      },
                      [mqMin.tabletLandscape]: {
                        maxHeight: '6.5em'
                      }
                    }}
                    p={{ default: 3 }}
                    pb={{ default: 3, mobile: 5 }}
                    pt={{ default: 3, mobile: 5 }}
                  >
                    <Card.Title
                      as="h3"
                      css={{ label: 'cardTitle' }}
                      variant="cardTitle"
                    >
                      {fieldCtaHeading}
                    </Card.Title>
                    {/* {fieldCardSubheader && (
                        <Box
                          css={(theme: LucidTheme) => [
                            {
                              label: 'cardSubheader',
                              marginTop: theme.space[5],
                              fontSize: theme.fontSizes[3],
                              lineHeight: theme.lineHeights.body,
                              fontWeight: theme.fontWeights.body,
                              whiteSpace: 'nowrap'
                            },
                            fieldImage && {
                              whiteSpace: 'normal'
                            }
                          ]}
                          dangerouslySetInnerHTML={{
                            __html: getProcessedValue(fieldCardSubheader)
                          }}
                        />
                      )} */}
                  </Card.Content>
                </Box>
              </Link>
            </Card>
          </Box>
        );
      })}
    </Box>
  );
};

export default CardTiles;
